import { render } from "./AndroidHelp.vue?vue&type=template&id=aa5006fc"
import script from "./AndroidHelp.vue?vue&type=script&lang=js"
export * from "./AndroidHelp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__